<template>
  <section class="team-area section-padding40 fix">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-7 col-lg-8">
          <div class="section-tittle text-center mb-55">
            <h2>Наші керівники гуртків</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <swiper
          class="swiper courses-actives px-2 pb-3"
          ref="swiper"
          :options="swiperOptions"
        >
          <swiper-slide
            class="team-active"
            v-for="leader in leaders"
            :key="leader.id"
          >
            <div class="single-cat text-center">
              <div class="cat-icon">
                <img :src="leader.avatar" :alt="leader.name" />
              </div>
              <div class="cat-cap">
                <h5>{{ leader.name }}</h5>
                <p>
                  <span>{{ leader.position }} </span>
                  <span v-for="(courseName, i) in leader.courseName" :key="i">
                    {{ courseName }}
                  </span>
                </p>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "Team",
  components: {
    Swiper,
    SwiperSlide
  },

  data: () => ({
    swiperOptions: {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: true,
      autoplay: {
        delay: 5000
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 1,
          spaceBetween: 40
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 30
        },
        640: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 20
        },
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 10
        }
      }
    }
  }),

  computed: {
    leaders() {
      return this.$store.getters.leaders;
    }
  },

  created() {
    this.$store.dispatch("FETCH_LEADERS");
  }
};
</script>

<style scoped lang="scss"></style>
